import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { BarcodedUnitListTable } from 'src/components/Table/list/BarcodedUnit'
import { ListPage } from 'src/components/Pages/ListPage'

export const BarcodedUnitListPage = () => {
  const paginator = useQueryPaginator(
    'barcoded-unit-list',
    skuit.sc.barcodedUnits.list
  )

  const exportFields = [
    'client_guid',
    'client_name',
    'guid',
    'path',
    'product_guid',
    'product_name',
  ]

  return (
    <ListPage
      title='Barcoded Units'
      paginator={paginator}
    >
      <BarcodedUnitListTable
        paginator={paginator}
        fields={['name', 'client', 'product', 'path']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.barcodedUnits.export
        }}
      />
    </ListPage>
  )
}
